import { render, staticRenderFns } from "./WidgetsReportInvoice.vue?vue&type=template&id=7d0b03bc&scoped=true"
import script from "./WidgetsReportInvoice.vue?vue&type=script&lang=js"
export * from "./WidgetsReportInvoice.vue?vue&type=script&lang=js"
import style0 from "./WidgetsReportInvoice.vue?vue&type=style&index=0&id=7d0b03bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0b03bc",
  null
  
)

export default component.exports